import { BannerSection } from "@/components/sections/section-banner";
import { BlogSection } from "@/components/sections/section-blog";
import { ColetaPersonalizadaSection } from "@/components/sections/section-coleta-personalizada";
import { ReembolsoIntegralSection } from "@/components/sections/section-integral-reembolso";
import { JourneySection } from "@/components/sections/section-journey";
import { ModalidadeTransporteSection } from "@/components/sections/section-modalidade-transporte";

import { PlataformaDigitalSection } from "@/components/sections/section-plataforma-digital";
import { RastreamentoTempoRealSection } from "@/components/sections/section-rastreamento-tempo-real";
import { RedeNacionalSection } from "@/components/sections/section-rede-nacional";
import { SegurosSection } from "@/components/sections/section-seguro";

import { HeroSuaEmpresaSection } from "@/components/heros/section-hero-sua-empresa";
import { ServicosSection } from "@/components/sections/section-servicos";
import { StatsSectionClear } from "@/components/sections/section-stats-clear";
import { TestimonialSection } from "@/components/sections/section-testimonial";
import { TransportSection } from "@/components/sections/section-transport";
import { TransportMessageSection } from "@/components/sections/section-transport-message";
import { WhereSection } from "@/components/sections/section-where";
export default function ParaSuaEmpresaPage() {
  return (
    <div className="min-h-screen bg-n-bg-1">
      <HeroSuaEmpresaSection />
      <WhereSection />
      <TransportSection />
      <ModalidadeTransporteSection />
      <ServicosSection />
      <RedeNacionalSection />
      <ColetaPersonalizadaSection />
      <RastreamentoTempoRealSection />
      <SegurosSection />
      <ReembolsoIntegralSection />
      <StatsSectionClear />
      <TransportMessageSection />
      <JourneySection />
      <PlataformaDigitalSection />
      <TestimonialSection />
      <BlogSection />
      <BannerSection title="Faça agora uma cotação e agende o transporte do seu veículo !" />
    </div>
  );
}
